import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cc71c11"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-left px-6 py-4" }
const _hoisted_3 = {
  key: 1,
  class: "px-6 py-4"
}
const _hoisted_4 = { key: 1 }

import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { UiPopconfirm } from '@/components/common/ui'
interface IDropdownMenuItem {
    label: string
    name: string
    handler: () => void
    confirmationClickRequired?: boolean
    confirmationQuestion?: string
    hidden?: boolean
}
interface IPropsDropdownMenu {
    items: IDropdownMenuItem[]
}

export default /*#__PURE__*/_defineComponent({
  props: {
    items: { type: Array, required: true }
  },
  setup(__props: any) {

const props = __props as {
    items: IDropdownMenuItem[]
}

const handle = (item: IDropdownMenuItem) => {
    if (item.handler) {
        item.handler()
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative inline-block text-left"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_unref(MenuButton), null, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "menu-button")
          ]),
          _: 3
        })
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-100 ease-out",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-100 ease-in",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MenuItems), { class: "menu-item absolute -right-1 mt-3 origin-top-right bg-white shadow-menu menu z-40" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
                  return (_openBlock(), _createBlock(_unref(MenuItem), {
                    key: `item-${item.name}`
                  }, {
                    default: _withCtx(({ active }) => [
                      (item.hidden !== true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass([
                                active ? 'bg-primary text-white' : 'text-dark-gray',
                                'text-left w-full font-basier text-base  whitespace-nowrap transition duration-500',
                            ]),
                            onClick: ($event: any) => (handle(item))
                          }, [
                            (item.confirmationClickRequired)
                              ? (_openBlock(), _createBlock(_unref(UiPopconfirm), {
                                  key: 0,
                                  "full-width": "",
                                  text: item.confirmationQuestion,
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                                  onConfirm: ($event: any) => (handle(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, _toDisplayString(item.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["text", "onConfirm"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.label), 1))
                          ], 10, _hoisted_1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})